<div *ngFor="let comp of company" >
<h1>{{ comp.fields.name }}</h1>
<p>{{ comp.fields.description }}</p>
</div>
